import styled from 'styled-components'

const PURPLE_THEME = {
  primary: '#7450aa',
  light: '#8b6eb8',
  dark: '#47306a',
  lightBg: '#c2b2da',
  veryLightBg: 'rgba(194, 178, 218, 0.2)',
  border: 'rgba(116, 80, 170, 0.15)',
}

export const BrandSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const BrandHeader = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0;
  color: ${PURPLE_THEME.primary};
  border-bottom: 2px solid ${PURPLE_THEME.border};
  padding: 16px 0;
  text-align: center;
  background: linear-gradient(135deg, ${PURPLE_THEME.primary} 0%, ${PURPLE_THEME.light} 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: all 0.2s ease;
`

export const ViewTemplatesButton = styled.div`
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 8px;
  background: ${PURPLE_THEME.primary};
  border: 1px solid ${PURPLE_THEME.dark};
  text-align: center;
  font-weight: 500;
  color: white;
  transition: all 0.2s ease;

  &:hover {
    background: ${PURPLE_THEME.dark};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(116, 80, 170, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`
